import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { Tokens } from "@/constants/index.js";
import { route } from "./route.js";
import DashboardMaster from "@/layout/dashboard/DashboardMaster.jsx";

export default function Router() {
    const token = localStorage.getItem(Tokens.ADMIN_TOKEN);
    const admin = localStorage.getItem("admin");
    const ActualAdminData = JSON.parse(admin)
    const prepareRoutes = () => {

        let filterRoutes = [];
        route.forEach((route) => {
            if (route.permission === ActualAdminData?.role) {
                filterRoutes.push(route)
            }
        });
        return filterRoutes;
    };

    const routes = prepareRoutes();
    return (
        <>
            {ActualAdminData?.role === 'user' ? <DashboardMaster>
                <Routes>
                    {routes.map((route, index) => {
                        return route.ele ? (
                            <Route key={index} exact={true} path={route.path} element={token ? route.ele : <Navigate replace to={"/signin"} />} />
                        ) : (null)
                    })}
                    <Route path='*' element={<Navigate replace to={"/"} />} />
                </Routes>
            </DashboardMaster> : <Routes>
                    {routes.map((route, index) => {
                        return route.ele ? (
                            <Route key={index} exact={true} path={route.path} element={token ? route.ele : <Navigate replace to={"/signin"} />} />
                        ) : (null)
                    })}
                    <Route path='*' element={<Navigate replace to={"/admin"} />} />
                </Routes>}
        </>
    )

}
